export default __webpack_public_path__ + "static/media/errorCodeCluster.2306de6e.svg";